import { render, staticRenderFns } from "./csvDropzoneComponent.vue?vue&type=template&id=bb0066ca&"
import script from "./csvDropzoneComponent.vue?vue&type=script&lang=ts&"
export * from "./csvDropzoneComponent.vue?vue&type=script&lang=ts&"
import style0 from "./csvDropzoneComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports